const initial = () => {
    const copyStringToClipboard = (copyText) => {
        const el = document.createElement('textarea');
        el.value = copyText;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    };

    document.querySelectorAll('.copy-to-clipboard').forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();

            let copyText;
            if (el.hasAttribute('data-clipboard-text')) {
                copyText = el.getAttribute('data-clipboard-text');
                copyStringToClipboard(copyText);
            } else {
                copyText = document.getElementById('password').value;
                copyStringToClipboard(copyText);
            }

            el.classList.remove('fa-clipboard');
            el.classList.add('fa-check');
            setTimeout(() => {
                el.classList.remove('fa-check');
                el.classList.add('fa-clipboard');
            }, 2000);
        });
    });
};

export default initial;
